<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">
        <div class="title" v-if="getModalData.id">Edit Section</div>
        <div class="title" v-if="!getModalData.id">Add Section</div>
      </h5>
      <button type="button" class="close" @click="$store.dispatch('closeModal', true)">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form class="form" @submit.prevent="onSubmit">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" v-model="form.name"/>
        </div>
        <div class="form__btn">
          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" v-if="getModalData.id">
            <img src="../../assets/img/btn-ok-icon.png"> <span>Save</span>
          </b-button>
          <b-button type="submit" variant="primary" class="mx-auto btn-image mt-4" v-else>
            <img src="../../assets/img/btn-ok-icon.png"> <span>Add</span>
          </b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'ModalSection',
    computed: {
      ...mapGetters([
        'getModalData',
      ]),
    },
    data() {
      return {
        form: {
          name: ''
        },
      }
    },
    mounted() {
      if (this.getModalData.id) {
        this.form = {
          name: this.getModalData.name
        }
      }
    },
    methods: {
      ...mapActions([
        'storeSection',
        'updateSection',
        'setToast',
      ]),
      onSubmit() {
        if (this.getModalData.id)
          this.updateSection([this.getModalData.id, this.form])
        else
          this.storeSection(this.form)
      },
    }
  }
</script>

<style scoped>

</style>